import { usePermissionCheck } from "../../_hooks/usePermissionCheck";
import NoAccessState from "../../_components/ui/NoAccessState";
import RouteFallback from "../../_components/loaders/RouteFallback";

/**
 * Route-level permission gate - the counterpart to `FeatureFlagRoute`
 * (org/plan feature flags), gating on the signed-in user's own permissions
 * instead. Composes inside `FeatureFlagRoute` so a disabled feature flag
 * still wins.
 *
 * Not-ready (permissions still loading) is deliberately never treated as
 * denied - `RouteFallback` is the same fallback `RootLayout` already shows
 * for lazy route chunks, so this doesn't introduce a new loading pattern.
 * Denied renders in-layout (not a full-page redirect) so the sidebar/header
 * stay put per the product decision that nav links remain clickable and the
 * page itself explains the block.
 *
 * @param {string} permission - dotted permission key required, e.g. "role.view"
 * @param {string} moduleName - human label for the no-access message, e.g. "Roles"
 * @param {React.ReactNode} children
 */
export const PermissionRoute = ({ permission, moduleName, children }) => {
  const { can, arePermissionsReady } = usePermissionCheck();

  if (!arePermissionsReady) {
    return <RouteFallback />;
  }

  if (!can(permission)) {
    return <NoAccessState moduleName={moduleName} />;
  }

  return <>{children}</>;
};

export default PermissionRoute;
